import { CustomerAccountNoActiveEquipmentImageProps } from '../../types';

export const CustomerAccountNoActiveEquipmentImage = ({
  image,
  altText
}: CustomerAccountNoActiveEquipmentImageProps) => {
  return <img src={image} alt={altText} />;
};
